/**
 * Interior Execution — unit detail host (P1).
 *
 * Thin wrapper that hosts the existing ExecutionPlanPanel (the 3-step
 * configure → review → plan flow) for one developer-approved unit, reached from
 * the Interior Execution list. Replaces the old home under Design Requests.
 */
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ExecutionPlanPanel from "./ExecutionPlanPanel";
import BoqSkuMappingPanel from "./BoqSkuMappingPanel";
import ChosenSkuBoqCard from "./ChosenSkuBoqCard";

const ExecutionUnitDetail = ({ basePath = "/interior-execution" }) => {
  const { leadId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <button
        onClick={() => navigate(basePath)}
        className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mb-4"
      >
        <ArrowLeft size={16} /> Back to units
      </button>
      <BoqSkuMappingPanel leadId={parseInt(leadId, 10)} />
      <ChosenSkuBoqCard leadId={parseInt(leadId, 10)} />
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <ExecutionPlanPanel leadId={parseInt(leadId, 10)} />
      </div>
    </div>
  );
};

export default ExecutionUnitDetail;
